import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import FreezeMembership from 'components/HomePageNew/FreezeMembership';

const FreezeMembershipPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <FreezeMembership {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default FreezeMembershipPage;
